module.exports = __webpack_public_path__ + "static/media/bg-notfound-mobile.bd5325e3.jpg";